import { ThemedStyledProps } from 'styled-components'
import { BorderProps } from '../../types/props'
import light from 'themes/light.theme'
import { overloadColor } from '../style'
import { isUndefined } from '../typechecks'

function borderStyle(
  border?: string,
  width?: string,
  style?: string,
  color?: string
) {
  let ret = ''
  if (!isUndefined(border)) ret += `border: ${border};`
  if (!isUndefined(width)) ret += `border-width: ${width};`
  if (!isUndefined(style)) ret += `border-style: ${style};`
  if (!isUndefined(color)) ret += `border-color: ${overloadColor(color)};`

  return ret
}

export function getBorderStyle(
  props: ThemedStyledProps<Partial<BorderProps>, typeof light>
) {
  return borderStyle(
    props.border,
    props.borderWidth,
    props.borderStyle,
    props.borderColor
  )
}
